import { z } from "zod";
import { baseSearchSchema, navigationSearchSchema } from "../-search-params";

export const tradeInSearchSchema = z.object({
	...baseSearchSchema.shape,
	...navigationSearchSchema.shape,
});

export type TradeInSearch = z.infer<typeof tradeInSearchSchema>;

export const validateTradeInSearch = (search: Record<string, unknown>): TradeInSearch => {
	return tradeInSearchSchema.parse(search);
};
